import axios from "@/api/axiosInstance";

/** Removes one KPI's thresholds on the active company. Responds 204. */
export const deleteKPIThreshold = async (kpiCode: string): Promise<void> => {
  await axios.delete(`/api/private/kpi-dashboard/thresholds/${kpiCode}`);
};
